import createHttp from '@/config/http';
import type { InventoriesResponse, Inventory } from '@/types/inventory';
import type { ResponseMetaData } from '@/types/service';

// localhost:3002 (Orders microservice port)
const http = createHttp(import.meta.env.VITE_ORDERS_URL);

export async function getInventories(
	page = 1,
	limit = 15,
	columnsFilters = '[]',
	search = '',
	status: string | number = '',
	globalFilters = '[]',
	sort = '',
): Promise<{
	items: Inventory[];
	meta: ResponseMetaData;
}> {
	const response = await http.get<InventoriesResponse>('/orders/inventories', {
		params: {
			page,
			limit,
			columnsFilters,
			search,
			status,
			globalFilters,
			sort,
		},
	});
	return {
		items: response.data.data.items,
		meta: {
			...response.data.data.metaData,
			itemsPerPage: response.data.data.metaData.recordsPerPage,
		},
	};
}

export const updateInventorybyDenial = async (
	inventoryId: string,
	updateData: {
		'ta_DenialSupport@odata.bind': string;
	},
): Promise<any> => {
	const response = await http.patch(
		`/orders/inventories/${inventoryId}`,
		updateData,
	);
	return response.data.data;
};
